import httpClient from "./httpClient";

const getIntroduction = () => httpClient.get("/Introduction/topsec/get?page=1&pageSize=1").then(
  (response) => {return response}
)

const  setIntroduction = (params) => httpClient.post("/Introduction/topsec/post",params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

const putIntroduction = (params,id) => httpClient.put(`/Introduction/topsec/put/${id}`, params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

const deleteIntroduction = (id) => httpClient.delete(`/Introduction/topsec/delete/${id}`, { headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })



export {
  getIntroduction ,
  setIntroduction,
  putIntroduction,
  deleteIntroduction
}
